import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import subsection_style from "./style.js";
// import Ply from "./Ply.js"
import ModelViewer from "./ModelViewer.js"

import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from "semantic-ui-react";


import sdf1 from "./images/sdf1.png";
import sdf2 from "./images/sdf2.png";

const SDF = () => (
  <div>
    <Header as="h2" textAlign="center" style={subsection_style}>
    Processing SDF
    </Header>
{/* 
    <Image src={sdf1} style={subsection_style}></Image>
    <Image src={sdf2} style={subsection_style}></Image>
    <p>Left: unprocessed geometry decoded from an unprocessed INR. Right: smoothened geometry decoded from the output INR of our INSP-Net.</p>
         */}
    <Grid columns={2}>
      <Grid.Row 
textAlign="center">
        <Grid.Column>
          <p  >Unprocessed geometry decoded from an unprocessed INR</p>
        </Grid.Column>
        <Grid.Column>
          <p >Smoothened geometry decoded from the output INR of our INSP-Net.</p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
            <ModelViewer file_path={"dragon_ori.glb"} camera_orbit={"0deg 0deg 40%"} />
        </Grid.Column>
        <Grid.Column>
            <ModelViewer file_path={"dragon_smoothed.glb"} camera_orbit={"0deg 0deg 40%"} />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
            <ModelViewer file_path={"armadillo_ori.glb"} camera_orbit={"200deg 300deg 80%"} />
        </Grid.Column>
        <Grid.Column>
            <ModelViewer file_path={"armadillo_smoothed.glb"} camera_orbit={"200deg 300deg 80%"}/>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
);

export default SDF;
